import type { StudioAsset } from "@/puck/types";

export function mergeStudioAsset(
  assets: StudioAsset[],
  asset: StudioAsset,
): StudioAsset[] {
  if (assets.some((entry) => entry.url === asset.url)) {
    return assets;
  }
  return [...assets, asset];
}

export function removeStudioAssetByUrl(
  assets: StudioAsset[],
  url: string,
): StudioAsset[] {
  return assets.filter((entry) => entry.url !== url);
}

export function studioAssetFromUploadResponse(data: {
  resourceId: string;
  url: string;
  filename: string;
}): StudioAsset {
  return {
    id: data.resourceId,
    url: data.url,
    filename: data.filename,
    uploadedAt: new Date().toISOString(),
  };
}
